import { Stack } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { KeywordManager } from "./keyword-manager";

export type IncludeExcludeState = {
    include: string[];
    exclude: string[];
};

interface IKeywordsIncludeExcludeTexts {
    includeTitle?: string;
    excludeTitle?: string;
    includePlaceholder?: string;
    excludePlaceholder?: string;
    addButtonText?: string;
    label?: string;
    labelFallback?: string;
    singleIncludingText?: string;
    singleExcludingText?: string;
    multipleFiltersText?: string;
}

interface IIncludeExcludeRendererProps {
    state?: IncludeExcludeState;
    onChange: (value: IncludeExcludeState) => void;
    texts?: IKeywordsIncludeExcludeTexts;
}

export const KeywordsIncludeExcludeRenderer = (props: IIncludeExcludeRendererProps) => {
    const { state = { include: [], exclude: [] }, onChange, texts = {} } = props;
    const translate = useTranslation();

    const defaultTexts: Required<IKeywordsIncludeExcludeTexts> = {
        includeTitle: translate("monitor_and_protect.competitors.filter.include_exclude_keywords.include_title"),
        excludeTitle: translate("monitor_and_protect.competitors.filter.include_exclude_keywords.exclude_title"),
        includePlaceholder: translate(
            "monitor_and_protect.competitors.filter.include_exclude_keywords.include_placeholder",
        ),
        excludePlaceholder: translate(
            "monitor_and_protect.competitors.filter.include_exclude_keywords.exclude_placeholder",
        ),
        addButtonText: translate("monitor_and_protect.competitors.filter.include_exclude_keywords.add_button"),
        label: translate("monitor_and_protect.competitors.filter.include_exclude_keywords.title"),
        labelFallback: translate("monitor_and_protect.competitors.filter.include_exclude_keywords.title"),
        singleIncludingText: translate(
            "monitor_and_protect.competitors.filter.include_exclude_keywords.including_single",
        ),
        singleExcludingText: translate(
            "monitor_and_protect.competitors.filter.include_exclude_keywords.excluding_single",
        ),
        multipleFiltersText: translate(
            "monitor_and_protect.competitors.filter.include_exclude_keywords.multiple_filters",
        ),
    };

    const finalTexts = { ...defaultTexts, ...texts };

    return (
        <Stack
            gap="16px"
            padding="16px 8px 0"
        >
            <KeywordManager
                title={finalTexts.includeTitle}
                placeholder={finalTexts.includePlaceholder}
                addButtonText={finalTexts.addButtonText}
                keywords={state.include}
                onKeywordsChange={(keywords) => {
                    onChange({
                        ...state,
                        include: keywords,
                    });
                }}
            />
            <KeywordManager
                strikethrough
                title={finalTexts.excludeTitle}
                placeholder={finalTexts.excludePlaceholder}
                addButtonText={finalTexts.addButtonText}
                keywords={state.exclude}
                onKeywordsChange={(keywords) => {
                    onChange({
                        ...state,
                        exclude: keywords,
                    });
                }}
            />
        </Stack>
    );
};
